import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL !== undefined ? process.env.REACT_APP_BACKEND_URL : "https://farniymart.com";
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

let _memToken = null;
try { _memToken = localStorage.getItem("fm_token"); } catch {}

export const setApiToken = (t) => {
  _memToken = t;
  try { if (t) localStorage.setItem("fm_token", t); else localStorage.removeItem("fm_token"); } catch {}
};

export const getApiTokenAsync = async () => {
  if (_memToken) return _memToken;
  try { return localStorage.getItem("fm_token"); } catch { return null; }
};

const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = _memToken || (() => { try { return localStorage.getItem("fm_token"); } catch { return null; } })();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      setApiToken(null);
      try { sessionStorage.removeItem("fm_user_cache"); } catch {}
    }
    return Promise.reject(err);
  }
);

export const inr = (v) => {
  if (v == null) return "—";
  return `₹${Number(v).toLocaleString("en-IN")}`;
};

export const optimizeImage = (url, w = 400) => {
  if (!url) return "";
  if (url.includes("res.cloudinary.com")) {
    return url.replace("/upload/", `/upload/w_${w},q_auto,f_auto/`);
  }
  if (url.includes("unsplash.com")) {
    const u = new URL(url);
    u.searchParams.set("w", String(w));
    u.searchParams.set("q", "80");
    u.searchParams.set("fm", "webp");
    return u.toString();
  }
  return url;
};

export default api;
